import React, { useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { handleUpdateToolbox, openUpdateToolbox } from '../../reducers/uiSlice';
import UniDialog from '../Common/UniDialog';
import AreaWrong from "./AreaWrong";
import ParcelReject from "./ParcelReject";
import ParcelUpdate from "./ParcelUpdate";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { useTranslation } from 'react-i18next';
import BatchesBoxUpdate from './BoxUpdate/BatchesBoxUpdate';
import ExcelBoxUpdate from './BoxUpdate/ExcelBoxUpdate';
import SecondDelivery from './SecondDelivery';
import ExceptionUpdate from './ExceptionUpdate';
import { getExceptionDetails } from '../../actions/editOrderActions';
import BatchUpdate from './BatchUpdate';
import OrderListDownload from './OrderListDownload';
import ReplanningRoute from './ReplanningRoute';
import ExpirationType from './ExpirationType';
import { getPartnerList } from '../../actions/mmActions';
import { useToken } from "../../utilities/hooks";
import UpdateDriverNotes from './UpdateDriverNotes';


const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    }
}));
const EXIPRATION_PROCESS_TYPE_MANAGEMENT = 311;
const UPDATE_NOTES_PROCESS_TYPE_MANAGEMENT = 312;
const ENABLE_REPLANNING_MANAGEMENT = 316;

function UpdateToolbox() {
    const classes = useStyles();
    const {t} = useTranslation('updateToolbox');
    const dispatch = useDispatch();

    const openModal = useSelector(openUpdateToolbox);

    const [value, setValue] = useState('0');
    const tokenContents = useToken();
    const userHasExpirationProcessTypeManagement = tokenContents.uiAbilities.includes(EXIPRATION_PROCESS_TYPE_MANAGEMENT);
    const updateNotesAbility= tokenContents.uiAbilities.includes(UPDATE_NOTES_PROCESS_TYPE_MANAGEMENT);
    const enableReplanning = tokenContents.uiAbilities.includes(ENABLE_REPLANNING_MANAGEMENT);
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    useEffect(() => {
        if(openModal) {
            setValue('0');
            dispatch(getExceptionDetails());
            dispatch(getPartnerList());
        }
    }, [openModal])

    return (
        <UniDialog
            title={t('title_update_toolbox')}
            fullWidth
            maxWidth='lg'
            disableDefaultButtons
            open={openModal}
            onClose={handleClose}
        >
            <div>
                <FormControl>
                    <RadioGroup
                        value={value}
                        onChange={handleChange}
                        row
                    >
                        <FormControlLabel value='0' control={<Radio />} label={t('wrong_area')} />
                        <FormControlLabel value='2' control={<Radio />} label={t('parcel_reject')} />
                        <FormControlLabel value='3' control={<Radio />} label={t('parcel_update')} />
                        <FormControlLabel value='1' control={<Radio />} label={t('box_update')} />
                        {/* <FormControlLabel value='4' control={<Radio/>} label={t('box_update_excel')}/> */}
                        {/* <FormControlLabel value='5' control={<Radio/>} label={t('batch_second_delivery')}/> */}
                        <FormControlLabel value='6' control={<Radio />} label={t('exception_batch_update')} />
                        <FormControlLabel value='7' control={<Radio />} label={t('status_batch_update')} />
                        <FormControlLabel value='8' control={<Radio />} label={t('download_order_list')} />
                        {
                            enableReplanning &&
                            <FormControlLabel value='9' control={<Radio />} label={t('re_planing_route_tool')} />
                        }

                        {userHasExpirationProcessTypeManagement && <FormControlLabel value='10' control={<Radio />} label={t('expiration_process_type')} />}
                        {updateNotesAbility && <FormControlLabel value='11' control={<Radio/>} label={t('update_order_note')}/>}

                    </RadioGroup>
                </FormControl>
            </div>
            <div style={{marginTop: 20}}>
                <div hidden={value !== '0'}>
                    <AreaWrong/>
                </div>
                <div hidden={value !== '1'}>
                    <BatchesBoxUpdate boxUpdate={value === '1'}/>
                </div>
                <div hidden={value !== '2'}>
                    <ParcelReject/>
                </div>
                <div hidden={value !== '3'}>
                    <ParcelUpdate/>
                </div>
                {/* <div hidden={value !== '4'}>
                    <ExcelBoxUpdate boxUpdate={value === '4'}/>
                </div> */}
                <div hidden={value !== '5'}>
                    <SecondDelivery/>
                </div>
                <div hidden={value !== '6'}>
                    <ExceptionUpdate exceptionUpdate={value === '6'}/>
                </div>
                <div hidden={value !== '7'}>
                    <BatchUpdate batchUpdate={value === '7'}/>
                </div>
                <div hidden={value !== '8'}>
                    <OrderListDownload/>
                </div>
                <div hidden={value !== '9'}>
                    <ReplanningRoute/>
                </div>
                <div hidden={value !== '10'}>
                    <ExpirationType/>
                </div>
                <div hidden={value !== '11'}>
                    <UpdateDriverNotes/>
                </div>
            </div>
        </UniDialog>
    );

    /**
     * close the dialog
     */
    function handleClose() {
        dispatch(handleUpdateToolbox(false))
    }
}

export default UpdateToolbox;
